import React from 'react';

import { makeStyles } from 'tss-react/mui';
import {Chip} from 'web-library';
import { KeyValueResponse } from '../../../../api';
import ControlledAutocomplete from '../../../../components/form-items/ControlledAutocomplete';

const useStyles = makeStyles()((theme) =>
({
  menuItemsContainer: {
    width: '65%',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },

  rootContainer: {
    display: 'flex',
    alignItems: 'center',
    minHeight: theme.spacing(6),
    padding: '0 !important',
  },
}));

interface IRegistrationExamLevel {
  label: string;
  data: any;
  onSetValue: (title: string, value: any) => void;
  onSetExamSeries: (value: any) => void;
  control: any;
  isError: boolean;
  errorMsg?: string;
  examSeriesValue: KeyValueResponse | null;
}

const renderTags = (tagValue: any, getTagProps: any) =>
  tagValue.map((option: { description: string }, tagIndex: any) => (
    <Chip
      id="auto-complete-subject"
      label={option.description}
      {...getTagProps({ index: tagIndex })}
    />
  ));

const EXAM_SERIES_PLACEHOLDER = 'Select Exam Series';

const RegistrationExamSeries = ({
  label,
  data,
  onSetExamSeries,
  onSetValue,
  control,
  isError,
  errorMsg,
  examSeriesValue,
}: IRegistrationExamLevel) => {
  const { classes } = useStyles();

  return (
    <ControlledAutocomplete<KeyValueResponse, false, false, undefined>
      id="inputSelect-examSeries"
      name="examSeries"
      control={control}
      label={label}
      options={data}
      className={classes.menuItemsContainer}
      classes={{
        root: classes.rootContainer,
      }}
      placeholder={EXAM_SERIES_PLACEHOLDER}
      error={isError}
      helperText={errorMsg}
      getOptionLabel={(option) => (typeof option === 'string' ? option : option.description)}
      isOptionEqualToValue={(option: KeyValueResponse, value: KeyValueResponse) =>
        option.code === value.code
      }
      renderTags={renderTags}
      onChange={(event: any, value: any) => {
        onSetExamSeries(value);
        onSetValue('examSeries', value || null);
      }}
      value={examSeriesValue}
      defaultValue={null}
    />
  );
};

export default RegistrationExamSeries;
